import React from 'react';
import { TextInput } from 'hyperdb-utils';
import api from 'api';
import { AddressForm } from '../../address';

export default class EntityForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeAddress = this.handleChangeAddress.bind(this);
  }
  componentWillUnmount() {
    this.props.onChange({}); // reset
  }
  render() {
    const address = this.props.entity.primary_address || {};
    return (
    <fieldset>
      <legend>Entity</legend>
      <TextInput
        label="First name *"
        name="first_name"
        value={ this.props.entity.first_name }
        onChange={ this.handleChange.bind(this, 'first_name') }
      />
      <TextInput
        label="Last name *"
        name="last_name"
        value={ this.props.entity.last_name }
        onChange={ this.handleChange.bind(this, 'last_name') }
      />
      <TextInput
        label="Email *"
        name="primary_email"
        value={ this.props.entity.primary_email }
        onChange={ this.handleChange.bind(this, 'primary_email') }
      />
      <TextInput
        label={ `Phone ${ this.props.mode === 'owner' ? ' *' : '' }` }
        name="primary_phone"
        value={ this.props.entity.primary_phone }
        onChange={ this.handleChange.bind(this, 'primary_phone') }
      />
      <AddressForm address={ address } onChange={ this.handleChangeAddress } mode={ this.props.mode } />
    </fieldset>
    );
  }

  handleChange(attributeName, field) {
    const { name, value } = field;
    const id = this.props.entity.id || '1';
    this.props.onChange({ ...this.props.entity, [attributeName]: value, id });
  }
  handleChangeAddress(address) {
    this.handleChange('primary_address', { value: address });
  }
}

EntityForm.propTypes = {
  api: React.PropTypes.object,
  entity: React.PropTypes.object,
  onChange: React.PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/entity/components/EntityForm.jsx